exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".authorFavourites__item{margin-top:30px}.authorFavourites__item:first-child{margin-top:0}.authorFavourites__item__icon{text-align:center;width:75px}.authorFavourites__link{display:block}.authorFavourites__link::after{clear:both;content:' ';display:block;font-size:0;height:0;overflow:hidden;width:100%}.authorFavourites__image{float:left;text-align:center;width:140px}.authorFavourites__content{margin-left:120px;position:relative;top:-5px}.authorFavourites__book{margin-bottom:7px}.authorFavourites__book__title{font-size:20.576px;font-size:1.286rem;margin-bottom:5px}.authorFavourites__book__authors{color:#bfbfbf;font-size:16px;font-size:1rem}.authorFavourites__comment{line-height:1.55}.authorFavourites__alacarte-badge{position:absolute;right:-19px;top:-19px}\n", ""]);

// exports
exports.locals = {
	"authorFavourites__item": "authorFavourites__item",
	"authorFavourites__item__icon": "authorFavourites__item__icon",
	"authorFavourites__link": "authorFavourites__link",
	"authorFavourites__image": "authorFavourites__image",
	"authorFavourites__content": "authorFavourites__content",
	"authorFavourites__book": "authorFavourites__book",
	"authorFavourites__book__title": "authorFavourites__book__title",
	"authorFavourites__book__authors": "authorFavourites__book__authors",
	"authorFavourites__comment": "authorFavourites__comment",
	"authorFavourites__alacarte-badge": "authorFavourites__alacarte-badge"
};